import React, { useState } from "react";
import {
  Box,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Heading,
  Text,
  VStack,
  Card,
  CardBody,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Image,
  useDisclosure,
    HStack,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDisease, faViruses } from "@fortawesome/free-solid-svg-icons";
import { StandardHeader } from "../themes/StandardHeader";

const vaccineData = {
  cattle: [
    { id: "V001", name: "วัคซีนป้องกันโรคปากและเท้าเปื่อย", usage: "ฉีดปีละ 2 ครั้ง", manufacturer: "บริษัท A" },
    { id: "V002", name: "วัคซีนป้องกันโรคเฮโมรายิกเซพติกซีเมีย", usage: "ฉีดปีละครั้ง", manufacturer: "บริษัท B" },
  ],
  pig: [
    { id: "V003", name: "วัคซีนป้องกันโรคปากเท้าเปื่อย (FMD)", usage: "ฉีดทุก 4 เดือน", manufacturer: "บริษัท C" },
    { id: "V004", name: "วัคซีนป้องกันอหิวาต์สุกร", usage: "ฉีดปีละ 2 ครั้ง", manufacturer: "บริษัท D" },
  ],
  poultry: [
    { id: "V005", name: "วัคซีนป้องกันโรคหลอดลมอักเสบติดต่อ", usage: "ให้ทางน้ำดื่ม", manufacturer: "บริษัท E" },
    { id: "V006", name: "วัคซีนป้องกันโรคไข้หวัดนก", usage: "ฉีดเข้าใต้ผิวหนัง", manufacturer: "บริษัท F" },
  ],
};

const highlights = [
  { title: "เลือกวัคซีนให้เหมาะสม", description: "ประกาศแจ้งเตือน และเฝ้าระวัง โรคติดต่อจากสัตว์สู่คน / สัตว์ป่าสู่สัตว์เลี้ยง ปัจจุบันมีรายงานโรคไข้หวัดนกแล้วที่รัฐฮาวายในมหาสมุทรแปซิฟิก แต่ยังไม่มีหลักฐานรายงานในไทย ซึ่งประกอบกับการเก็บข้อมูลนกอย่างต่อเนื่องของทีมงานทำให้เห็นแนวโน้มที่กลุ่มนกน้ำ และนกนักล่าจะเป็นนกร่วงหล่น หมดแรง หรือเจ็บป่วยโดยไม่ทราบสาเหตุมากขึ้น ขอให้ผู้ที่ทำงานหรือเกี่ยวข้องกับสัตว์ปีก ให้ระมัดระวังป้องกันตัวเองหากต้องสัมผัสนก ซากนก สิ่งคัดหลั่ง และช่วยแนะนำแก่ผู้อื่นที่สัมผัสนก รวมถึงกำจัดซากนกอย่างปลอดภัย" },
  { title: "กทม. ประกาศเตือน โปรดเฝ้าระวัง ", description: "พบสัตว์ป่วยด้วยโรคพิษสุนัขบ้า บริเวณศูนย์กำจัดขยะมูลฝอย ซอย อ่อนนุช 86 แขวงประเวศ เขตประเวศ กรุงเทพมหานคร ประชาชนที่อยู่บริเวณดังกล่าวและชุมชนโดยรอบในรัศมี 5 กิโลเมตร ขอให้หลีกเลี่ยงการสัมผัสสัตว์จรจัดในพื้นที่โดยเด็ดขาด" },
];

const VaccineInfo = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedDisease, setSelectedDisease] = useState(null);

  const openDiseaseModal = (diseaseName, imageUrl) => {
    setSelectedDisease({ name: diseaseName, image: imageUrl });
    onOpen();
  };

  const filterVaccines = (category) => {
    return vaccineData[category].filter((vaccine) =>
      vaccine.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
      <Box p={6} maxW="1200px" mx="auto">
            {/* Header */}
            <Box
                mb={5}
                borderRadius="full"
                w="100%"
                bgColor="iBlue.600"
                color="white"
                p={2} 
            >     
              <HStack spacing={5} ml={5}>
                <FontAwesomeIcon icon={faViruses} color="white" size="xl" />
                <Heading as="h1" size={{ base: "md", md: "lg" }} fontWeight="normal">
                    สถานการณ์การเกิดโรคระบาดที่เกิดขึ้นล่าสุด
                </Heading>
              </HStack>
            </Box>



      {/* Highlights */}
      <Grid templateColumns="repeat(2, 1fr)" gap={6} mb={6}>
        {highlights.map((highlight, index) => (
          <Card key={index} borderRadius="lg" p={4} boxShadow="md">
            <CardBody>
              <Heading size="md" mb={2}>
                {highlight.title}
              </Heading>
              <Text>{highlight.description}</Text>
            </CardBody>
          </Card>
        ))}
      </Grid>

      {/* Vaccine List Tabs */}
      <Tabs variant="enclosed">
        <TabList>
          <Tab>โรคระบาดล่าสุด</Tab>
          <Tab>โรคระบาดในโค-กระบือ</Tab>
          <Tab>โรคระบาดในสัตว์ปีก</Tab>
          <Tab>โรคระบาดในสุกร</Tab>
          <Tab>โรคระบาดอื่นๆ</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <VStack align="stretch" spacing={4}>
                <Box
                  p={4}
                  borderWidth="1px"
                  borderRadius="lg"
                  _hover={{ bg: "gray.50", cursor: "pointer" }}
                  onClick={() => openDiseaseModal("โรคพิษสุนัขบ้า", "https://dcontrol.dld.go.th/webnew/images/LINE_ALBUM_Rabies_250305.jpg")}
                >
                  <Heading size="md">โรคพิษสุนัขบ้า</Heading>
                  <Text>ดูรายงานสถานการณ์</Text>
                </Box>
                <Box
                  p={4}
                  borderWidth="1px"
                  borderRadius="lg"
                  _hover={{ bg: "gray.50", cursor: "pointer" }}
                  onClick={() => openDiseaseModal("โรคเฮโมรายิกเซนติกซีเมีย", "https://dcontrol.dld.go.th/webnew/images/LINE_ALBUM_Haemo_241223.jpg")}
                >
                  <Heading size="md">โรคเฮโมรายิกเซนติกซีเมีย</Heading>
                  <Text>ดูรายงานสถานการณ์</Text>
                </Box>
            </VStack>
          </TabPanel>
          <TabPanel>
            <VStack align="stretch" spacing={4}>
                <Box
                  p={4}
                  borderWidth="1px"
                  borderRadius="lg"
                  _hover={{ bg: "gray.50", cursor: "pointer" }}
                  onClick={() => openDiseaseModal("โรคเฮโมรายิกเซนติกซีเมีย", "https://dcontrol.dld.go.th/webnew/images/LINE_ALBUM_Haemo_241223.jpg")}
                >
                  <Heading size="md">โรคเฮโมรายิกเซนติกซีเมีย</Heading>
                  <Text>ดูรายงานสถานการณ์</Text>
                </Box>
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
                <Box
                  p={4}
                  borderWidth="1px"
                  borderRadius="lg"
                  _hover={{ bg: "gray.50", cursor: "pointer" }}
                  onClick={() => openDiseaseModal("โรคพิษสุนัขบ้า", "https://dcontrol.dld.go.th/webnew/images/LINE_ALBUM_Rabies_250305.jpg")}
                >
                  <Heading size="md">โรคพิษสุนัขบ้า</Heading>
                  <Text>ดูรายงานสถานการณ์</Text>
                </Box>
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* ✅ Modal แสดงภาพ */}
      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedDisease?.name}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedDisease?.image && (
              <Image
                src={selectedDisease.image}
                alt={selectedDisease.name}
                w="100%"
                borderRadius="md"
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default VaccineInfo;
